import { StringAdapter } from "../StringAdapter";

import { ColumnDefinition } from "../../model/ColumnDefinition";

export class DealtCcyPairAdapter extends StringAdapter {
  constructor() {
    super();
  }

  retrieveData(order: any, columnProperty: string): string {
    if (order["isInvertedOrderFg"]) {
      return order["nonBaseCode"] + "/" + order["baseCode"];
    }
    return order["baseCode"] + "/" + order["nonBaseCode"];
  }

  retrieveFilter(order: any, columnProperty: string): string {
    return this.retrieveData(order, columnProperty);
  }

  retrieveSearch(order: any, columnProperty: string): any {
    return this.retrieveFilter(order, columnProperty);
  }
}
